import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
/** @class PropertyCardFlexWrapperMixin */

/** @method */

export var PropertyCardFlexWrapperMixin = function PropertyCardFlexWrapperMixin(props) {
  return css(["padding:", ";"], spaceMixin("xs")(props));
};